import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {EformService} from "../../../service/eform.service";

@Component({
   selector: 'app-toggle',
   templateUrl: './toggle.component.html',
   styleUrls: ['./toggle.component.css']
})
export class ToggleComponent implements OnInit, AfterViewInit{
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() fieldName: any;
   @Input() isViewOnly: boolean;
   @Input() haveSign: boolean;
   value: boolean;
   constructor(private eformService: EformService, private cdr: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      if (this.eformService.eForm.value.value && typeof this.eformService.eForm.value.value[this.fieldName] === 'boolean') {
         this.value = this.eformService.eForm.value.value[this.fieldName]
         this.form.controls[this.fieldName].setValue(this.value);
      } else {
         if (this.field.radioDefaultValue && this.field.radioDefaultValue !== '') {
            this.value = this.field.radioDefaultValue;
         } else {
            this.value = null;
         }
         this.form.controls[this.fieldName].setValue(this.value);
      }
      if (this.haveSign) {
         this.isViewOnly = false;
      }
   }

   setValue($event: any) {
      if($event.checked){
         this.value = true;
         this.form.controls[this.fieldName].setValue(this.value);
      }else{
         this.value = false;
         this.form.controls[this.fieldName].setValue(this.value);
      }
   }

   ngAfterViewInit(): void {
      if (this.eformService.isNotCompleteAllSign) {
         this.isViewOnly = true;
      }
      this.cdr.detectChanges();
   }
}
